/**
 * Keep in sync with backend/src/services/bpml-helpers.ts `isBpmlHierarchyLeaf`.
 * Front and API stay separate (no shared package).
 */
type BpmlGrain = {
  domain?: string;
  macroProcess?: string;
  businessProcess?: string;
  subProcess?: string | null;
  task?: string | null;
};

export function isBpmlHierarchyLeaf(line: BpmlGrain, all: BpmlGrain[]): boolean {
  const domain = (line.domain ?? "").toUpperCase();
  const macro = (line.macroProcess ?? "").toLowerCase();
  const business = (line.businessProcess ?? "").toLowerCase();
  const sub = (line.subProcess ?? "").trim().toLowerCase();
  const task = (line.task ?? "").trim().toLowerCase();
  return !all.some((other) => {
    if ((other.domain ?? "").toUpperCase() !== domain) return false;
    if ((other.macroProcess ?? "").toLowerCase() !== macro) return false;
    if ((other.businessProcess ?? "").toLowerCase() !== business) return false;
    const os = (other.subProcess ?? "").trim().toLowerCase();
    const ot = (other.task ?? "").trim().toLowerCase();
    if (os === sub && ot === task) return false;
    if (!sub && !task && (os || ot)) return true;
    if (sub && !task && os === sub && Boolean(ot)) return true;
    return false;
  });
}
